import { gql } from '@apollo/client';
import { EntityCategoryFragment } from '../entityCategories';
import { PageInfoFragment, VersionFieldsFragment } from '../fragments';
import { CohortFragment, CohortInspectFieldFieldsFragment } from './fragments';

export const GET_NAMED_COHORT = gql`
  query NamedCohortQuery($id: ID!) {
    namedCohort(id: $id) {
      ...CohortFields
    }
  }
  ${CohortFragment}
`;

export const GET_NAMED_COHORTS = gql`
  query GetNamedCohorts(
    $schemaId: ID
    $includes: [ID!]!
    $term: String
    $includeCompound: Boolean
    $pagination: Pagination
  ) {
    namedCohorts(
      schemaId: $schemaId
      includes: $includes
      term: $term
      includeCompound: $includeCompound
      pagination: $pagination
    ) {
      entities {
        ...CohortFields
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${CohortFragment}
  ${PageInfoFragment}
`;

const DictionaryNamedCohortFragment = gql`
  fragment DictionaryNamedCohortFields on Cohort {
    ... on CompoundCohort {
      id
      version {
        ...VersionFields
      }
      categories {
        ...EntityCategoryFields
      }
      isFavorite
      isManaged
    }
    ... on ExpressionCohort {
      id
      version {
        ...VersionFields
      }
      categories {
        ...EntityCategoryFields
      }
      isFavorite
      isManaged
    }
    ... on FunnelCohort {
      id
      version {
        ...VersionFields
      }
      categories {
        ...EntityCategoryFields
      }
      isFavorite
      isManaged
    }
    ... on MeasureCohort {
      id
      version {
        ...VersionFields
      }
      categories {
        ...EntityCategoryFields
      }
      isFavorite
      isManaged
    }
    ... on PerformedCohort {
      id
      version {
        ...VersionFields
      }
      categories {
        ...EntityCategoryFields
      }
      isFavorite
      isManaged
    }
    ... on RetentionCohort {
      id
      version {
        ...VersionFields
      }
      categories {
        ...EntityCategoryFields
      }
      isFavorite
      isManaged
    }
  }
  ${VersionFieldsFragment}
  ${EntityCategoryFragment}
`;

export const GET_DICTIONARY_NAMED_COHORTS = gql`
  query GetDictionaryNamedCohorts(
    $schemaId: ID
    $includes: [ID!]!
    $term: String
    $includeCompound: Boolean
    $pagination: Pagination
  ) {
    namedCohorts(
      schemaId: $schemaId
      includes: $includes
      term: $term
      includeCompound: $includeCompound
      pagination: $pagination
    ) {
      entities {
        ...DictionaryNamedCohortFields
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${DictionaryNamedCohortFragment}
  ${PageInfoFragment}
`;

export const GET_COHORT_INSPECT_FIELDS = gql`
  query GetCohortInspectFields(
    $term: String
    $schemaId: ID!
    $func: String
    $context: FieldContext!
    $events: [EventInput!]!
    $includeFields: [String!]!
  ) {
    fields(
      term: $term
      schemaId: $schemaId
      func: $func
      context: $context
      events: $events
      includeFields: $includeFields
    ) {
      ...CohortInspectFieldFields
    }
  }
  ${CohortInspectFieldFieldsFragment}
`;
